import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { maskDateBR } from "@/common/utils/mask";

import {
  baseInput,
  baseTextarea,
  baseSelect,
  baseDate,
} from "@/common/components";

import { SamplePayloadType } from "@/common/types/sample";

import { ItemStatusEnum } from "@/common/types/enum";


export default /*@__PURE__*/_defineComponent({
  __name: 'sample',
  props: {
    data: {},
    title: {},
    width: { default: "100%" },
    methods: {},
    showMethod: { type: Boolean, default: false },
    showStatus: { type: Boolean, default: false },
    isPatch: { type: Boolean, default: false },
    inUse: { type: Boolean, default: false }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const defaultData = {
  code: "",
  description: null,
  name: "",
  status: null,
  method_id: null,
  stability: null,
  validity: null,
};

const payload = ref<SamplePayloadType>({ ...defaultData });

const statusUnusedEnum = computed(
  () => tm("enums.item_status") as Record<string, string>,
);

const statusInUseEnum = computed(() => ({
  [ItemStatusEnum.IN_USE]: t("enums.item_status.IN_USE"),
  [ItemStatusEnum.DEFECT]: t("enums.item_status.DEFECT"),
  [ItemStatusEnum.BROKEN]: t("enums.item_status.BROKEN"),
}));

const statusOptions = computed(() => {
  if (props.inUse) {
    return Object.entries(statusInUseEnum.value).map(([key, value]) => ({
      option: value,
      value: key,
    }));
  }

  return Object.entries(statusUnusedEnum.value).map(([key, value]) => ({
    option: value,
    value: key,
  }));
});

function update(key: keyof SamplePayloadType) {
  if (props.isPatch) {
    emit("update-data", { [key]: payload.value[key] });
    return;
  }

  emit("update-data", payload.value);
}

function maskCode(value: string) {
  return value?.replaceAll(" ", "-")?.toUpperCase();
}

watchEffect(() => {
  if (props.data) {
    payload.value = {
      code: props.data.code,
      description: props.data.description,
      name: props.data.name,
      status: props.data.status,
      method_id: props.data.method_id,
      stability: props.data.stability,
      validity: props.data.validity,
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.code) = $event)),
        value: payload.value.code,
        placeholder: _unref(t)('common.placeholders.code'),
        mask: maskCode,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (update('code')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.code")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (update('name')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      (__props.showStatus)
        ? (_openBlock(), _createBlock(_unref(baseSelect), {
            key: 0,
            modelValue: payload.value.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.status) = $event)),
            value: payload.value.status,
            options: statusOptions.value,
            "is-empty": false,
            onChange: _cache[5] || (_cache[5] = ($event: any) => (update('status')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(baseDate), {
        modelValue: payload.value.validity,
        "onUpdate:modelValue": [
          _cache[6] || (_cache[6] = ($event: any) => ((payload.value.validity) = $event)),
          _cache[7] || (_cache[7] = ($event: any) => (update('validity')))
        ],
        value: payload.value.validity,
        required: true,
        "value-mask": "YYYY-MM-DD",
        placeholder: "--/--/----"
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.validity")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value"]),
      (__props.showMethod && __props.methods)
        ? (_openBlock(), _createBlock(_unref(baseSelect), {
            key: 1,
            modelValue: payload.value.method_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.method_id) = $event)),
            value: payload.value.method_id,
            options: __props.methods,
            "is-empty": true,
            onChange: _cache[9] || (_cache[9] = ($event: any) => (update('method_id')))
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.method")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[11] || (_cache[11] = ($event: any) => (update('description')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})